import React from 'react';
export function ProblemSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-101">
      <div className="max-w-3xl mx-auto" data-id="element-102">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#F9327E]" data-id="element-103">
          NO TODOS LOS ALUMNOS APRENDEN DE LA MISMA MANERA
        </h2>

        <p className="text-lg mb-5 text-center text-gray-700" data-id="element-104">
          Los materiales tradicionales suelen ser saturados, caóticos y poco
          accesibles.
        </p>

        <p className="text-lg md:text-xl text-center font-[800] text-[#3CD0E4]" data-id="element-105">
          Pensado para acompañar alumnos con TDAH, TEA, Dislexia y distintos
          ritmos de aprendizaje.
        </p>
      </div>
    </section>;
}